import { Typography, TypographyProps } from '@mui/material';
import styled from '@emotion/styled';
import { media } from '../../theme/breakpoints';

export const Title = styled(Typography)<TypographyProps>`
    font-family: 'YuGothic';
    font-weight: 700;
    font-size: 21px;
    line-height: 42px;
    border-bottom: 1px solid #000;
    display: inline-block;

    /* breakpoints.tsのmedia.mobileを利用 */
    ${media.mobile} {
        font-size: 15px;
        line-height: 30px;
    }
`;
